import graphql from "babel-plugin-relay/macro";
import { readInlineData } from "react-relay";

import { lessonTypeHasRateForMembershipType_lessonType$key } from "./__generated__/lessonTypeHasRateForMembershipType_lessonType.graphql";

export const lessonTypeHasRateForMembershipType = (
  lessonTypeRef: lessonTypeHasRateForMembershipType_lessonType$key | null,
  membershipTypeId: string
) => {
  const lessonType = readInlineData(FragmentString, lessonTypeRef);
  if (!lessonType) return false;

  return lessonType?.lessonTypeRates?.edges?.some((edge) => {
    const rate = edge?.node;
    if (!rate) return false;
    if (rate.allMembershipTypes) return true;
    return rate?.membershipTypes?.edges?.some(
      (m) => m?.node?.id === membershipTypeId
    );
  });
};

const FragmentString = graphql`
  fragment lessonTypeHasRateForMembershipType_lessonType on LessonType @inline {
    lessonTypeRates: rates {
      edges {
        node {
          allMembershipTypes
          membershipTypes {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`;
